import { render, staticRenderFns } from "./tizhong.vue?vue&type=template&id=5d14a152&scoped=true&"
import script from "./tizhong.vue?vue&type=script&lang=ts&"
export * from "./tizhong.vue?vue&type=script&lang=ts&"
import style0 from "./tizhong.vue?vue&type=style&index=0&id=5d14a152&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d14a152",
  null
  
)

export default component.exports